import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { animated, useSpring, config } from 'react-spring';

export interface IOverlay {
  visible?: boolean;
}

const OverlayStyled = styled(animated.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${({ theme }) => theme.palette.background.primary};
`;

export const Overlay: FC<IOverlay> = ({ visible, ...restProps }) => {
  const [animation, setAnimation] = useSpring(() => ({
    opacity: 0,
    config: config.stiff,
  }));

  useEffect(() => {
    setAnimation({
      opacity: visible ? 1 : 0,
    });
  }, [visible, setAnimation]);

  return (
    <OverlayStyled
      {...restProps}
      style={{ ...animation, pointerEvents: visible ? 'all' : 'none' }}
    />
  );
};
